import { UseFormReturn } from "react-hook-form";
import BaseDialog from "@/components/Modals/BaseDialog";
import { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";
import { ConfigFormRenderer } from "@/components/Form/ConfigFormRenderer";

/**
 * A quick action whose options are too many to expand inside the tools list.
 * Edits write straight into the agent form, which saves them, so there is
 * nothing to confirm or discard: the dialog only closes.
 */
export const ToolSettingsDialog = ({
  isOpen,
  onOpenChange,
  title,
  description,
  config,
  form,
  fieldPrefix,
  isReadOnly,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  config: Record<string, NoxusFormEntryConfig>;
  form: UseFormReturn;
  fieldPrefix?: string;
  isReadOnly?: boolean;
}) => (
  <BaseDialog
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    title={title}
    description={description}
    size="2xl"
    footerActions={[
      { label: "Done", props: { onClick: () => onOpenChange(false) } },
    ]}
  >
    <ConfigFormRenderer
      config={config}
      form={form}
      fieldPrefix={fieldPrefix}
      isReadOnly={isReadOnly}
      flattenAccordions
    />
  </BaseDialog>
);
